import React from "react";
import { Footprints, Hand, Music, IdCard, X } from "lucide-react";
import { FONT, SAFE_BOTTOM, GLASS, glassBox, glassInner, namaKota } from "../kota/ui";
import { AvatarCanvas } from "./AvatarCanvas";

// Kartu pemain yang diketuk — melayang di atas bar obrolan. Baris 1: karakter, @username, Lv · nama · kota, tutup.
// Baris 2: aksi Hampiri / Lambai / Ajak joget / Lihat KWJ.
export function KartuPemain({ p, onHampiri, onLambai, onJoget, onKTW, onClose }) {
  const Tombol = ({ Icon, label, onClick, testid, aksen }) => (
    <button data-testid={testid} onClick={onClick} aria-label={label}
      style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 4, borderRadius: 16, padding: "8px 0 6px", cursor: "pointer", fontFamily: FONT,
        ...glassInner(true), background: aksen ? GLASS.accent : GLASS.innerOn, color: aksen ? "#fff" : GLASS.ink, WebkitTapHighlightColor: "transparent" }}>
      <Icon size={18} />
      <span style={{ fontSize: 10.5, fontWeight: 800 }}>{label}</span>
    </button>
  );
  return (
    <div data-testid="kartu-pemain" style={{ position: "absolute", left: 0, right: 0, bottom: `calc(${SAFE_BOTTOM} + 108px)`, display: "flex", justifyContent: "center", pointerEvents: "none", fontFamily: FONT, zIndex: 6 }}>
      <div style={{ ...glassBox, background: GLASS.bgStrong, borderRadius: 24, padding: 12, width: "calc(100% - 24px)", maxWidth: 536, display: "flex", flexDirection: "column", gap: 10, pointerEvents: "auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ width: 50, height: 50, borderRadius: 16, background: "var(--g-inner-on)", display: "grid", placeItems: "center", flex: "none", overflow: "hidden" }}>
            <AvatarCanvas av={p.avatar} size={58} />
          </span>
          <div style={{ flex: 1, minWidth: 0, lineHeight: 1.2 }}>
            <b data-testid="kartu-pemain-nama" style={{ fontSize: 14.5, display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>@{p.username || p.nama}</b>
            <span style={{ fontSize: 11.5, color: GLASS.sub, fontWeight: 600, display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>Lv {p.lv} · {p.nama} · Kota {namaKota(p.kota)}</span>
          </div>
          <button data-testid="kartu-pemain-tutup" aria-label="Tutup" onClick={onClose} style={{ width: 32, height: 32, borderRadius: 99, border: 0, background: "var(--g-inner)", color: GLASS.ink, display: "grid", placeItems: "center", cursor: "pointer", flex: "none" }}><X size={15} /></button>
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          <Tombol Icon={Footprints} label="Hampiri" onClick={onHampiri} testid="pemain-hampiri" aksen />
          <Tombol Icon={Hand} label="Lambai" onClick={onLambai} testid="pemain-lambai" />
          <Tombol Icon={Music} label="Ajak joget" onClick={onJoget} testid="pemain-joget" />
          <Tombol Icon={IdCard} label="Lihat KWJ" onClick={onKTW} testid="pemain-ktw" />
        </div>
      </div>
    </div>
  );
}
